import { observer } from 'mobx-react';
import menuGroupImprovementStore from '../../store/menuGroupImprovementStore';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import { formatImagePath } from 'src/utils/formatter';

const EmptyScreen = observer((): JSX.Element => {
  if (menuGroupImprovementStore.isRequestWasSended) {
    return (
      <div className="d-flex flex-column flex-grow-1 pt-4">
        <div className="d-flex flex-column justify-content-center align-items-center mt-6">
          <img
            src={formatImagePath(`${Icons.MenuGroups}.svg`)}
            alt={localeStore.t('menu_healthchecker_menu_is_ok')}
            className="image__no-found mb-6"
          />
          <p className="family-medium text-size-24 color-gray2">{localeStore.t('menu_healthchecker_menu_is_ok')}</p>
        </div>
      </div>
    );
  }
  return (
    <div className="d-flex flex-column flex-grow-1">
      <p className="family-regular text-size-20 color-gray4 mr-4">{localeStore.t('menu_healthchecker_page_description_placeholder')}</p>
    </div>
  );
});

export default EmptyScreen;
